export default class Notices {
	constructor() {
		this.noticesBox = document.querySelector(".woocommerce-notices-wrapper");
	}

	addNotices(notices, time = 0) {
		this.noticesBox.innerHTML = notices;

		if (time !== 0) {
			setTimeout(() => {
				this.noticesBox.innerHTML = "";
			}, time);
		}
	}
}
